var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgAdFeedbackAlert = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("rect", {
    width: 52.979,
    height: 70.491,
    x: 21.75,
    y: 13.75,
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeWidth: 1.5,
    rx: 3.25
  }), React.createElement("rect", {
    width: 7.783,
    height: 1.5,
    x: 56.995,
    y: 63.782,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 8.269,
    height: 1.5,
    x: 29.755,
    y: 57.459,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 23.348,
    height: 1.5,
    x: 29.755,
    y: 51.135,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 7.783,
    height: 1.5,
    x: 56.995,
    y: 51.135,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 23.348,
    height: 1.5,
    x: 41.43,
    y: 57.459,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("rect", {
    width: 23.348,
    height: 1.5,
    x: 29.755,
    y: 63.782,
    fill: borderColor,
    rx: 0.75
  }), React.createElement("path", {
    fill: color,
    d: "M29.755 74.078a3 3 0 0 1 3-3h13.458a3 3 0 0 1 0 6H32.755a3 3 0 0 1-3-3Z"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M42.489 37.007a6.128 6.128 0 1 0-12.257 0 6.128 6.128 0 0 0 12.257 0Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m45.747 36.997 9.947-8.262"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M65.163 37.008a6.128 6.128 0 1 0-12.257 0 6.128 6.128 0 0 0 12.257 0Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M59.036 37.007c-5.676-9.606-.203-16.573-6.753-14.827"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M55.974 26.768H43.717L36.363 37.01l9.208.145M45.747 36.997l-2.576-12.87M41.37 24.082h3.929"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M55.797 76.647 71.53 64.59c1.666-1.385 4.228-.453 4.614 1.68l4.3 19.348c.386 2.132-1.697 3.865-3.747 3.119l-20.034-7.292c-2.05-.746-2.53-3.412-.865-4.798Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "M73.06 70.595a.747.747 0 0 1 .436 1.016l-2.272 4.6c-.209.43-.655.515-.999.39l-.664-.242c-.252-.092-.548-.42-.434-.911l1.148-5.01c.057-.264.474-.697 1.09-.46l1.695.617Zm-4.81 10.418a1.72 1.72 0 1 1 1.177-3.233 1.72 1.72 0 0 1-1.177 3.233Z",
    clipRule: "evenodd"
  }));
};
export default SvgAdFeedbackAlert;